export const getDefaultFavoriteListKeys = {
  all: ['getDefaultFavoriteList'] as const,
  customerId: (customerId: string) => {
    return [...getDefaultFavoriteListKeys.all, customerId]
  },
  withFavoriteLists: (customerId: string, listId: string) => {
    return [...getDefaultFavoriteListKeys.customerId(customerId), listId]
  },
} as const
